module.exports = __webpack_public_path__ + "static/media/open-closed-button-open-on.aa8a9ab4.png";